import { createContext } from "react";
import { type PlanId } from "@services/jointBillServiceProviderBillPlans/types";
import { type INonProfitProvider } from "@services/nonProfits/types";
import { type IPoaSpRequest } from "@services/powersOfAttorney/types";

export interface IJointBillContext {
  isSummaryMode?: boolean;
  isArchiveMode?: boolean;
  nonProfitProviders?: INonProfitProvider[];
  poaSpRequests?: IPoaSpRequest[];
  jointBillServiceProviderBillPlanId?: PlanId;
}

export const JointBillContext = createContext<IJointBillContext>({});
